module.exports = __webpack_public_path__ + "static/media/31JFA9.4e91c8a1.jpg";